// サードパーティスクリプト向けの localStorage/sessionStorage 保護
// モバイル WebView で Storage が null の場合の TypeError を防止
// サードパーティ iframe やプライバシーモードで Storage アクセスが拒否された場合の SecurityError にも対応
// 参考: Plausible Analytics などの外部スクリプトが sessionStorage にアクセスする際のエラー防止

// noopStorage: 値を保持しないno-op実装
// Storage APIの互換性を保ちつつ、実際には何も保存しない
const noopStorage = {
  length: 0,
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
  clear: () => {},
  key: () => null,
}

/**
 * 指定された Storage オブジェクトがアクセス可能かテストし、
 * 不可能な場合は noopStorage でフォールバックする
 * @param {string} storageName - 'localStorage' または 'sessionStorage'
 */
function protectStorage (storageName) {
  // ブラウザ環境でない場合は何もしない（SSR、Web Worker等）
  if (typeof window === 'undefined') return

  let storageAccessible = false
  try {
    const testKey = '__storage_test__'
    window[storageName].setItem(testKey, testKey)
    window[storageName].removeItem(testKey)
    storageAccessible = true
  } catch (e) {
    // SecurityError または QuotaExceededError - Storage は使用不可
  }

  if (!storageAccessible) {
    try {
      Object.defineProperty(window, storageName, {
        value: noopStorage,
        writable: true,
        configurable: true,
      })
    } catch (e) {
      // Storage を上書きできない - アクセス不可のまま
      // 開発環境でのみ警告を出力（デバッグ用）
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn(`[Storage Protection] ${storageName}の保護に失敗しました:`, e.name)
      }
    }
  }
}

// localStorage と sessionStorage の両方を保護
protectStorage('localStorage')
protectStorage('sessionStorage')
